import type { Submission } from "~~/types/index-db";

export function useSubmissionDB() {
  const dbPromise = getIndexDbPromise();

  async function saveSubmission(submission: Submission) {
    const db = await dbPromise;
    if (!submission.createdAt) submission.createdAt = Date.now();
    try {
      await db.put("submissions", submission);

      return { success: true, error: null };
    } catch (error: any) {
      if (error instanceof DOMException || error instanceof Error) {
        return { success: false, error: error.message };
      }

      return { success: false, error: "An unknown error occurred." };
    }
  }

  async function getSubmission(
    id: number,
  ): Promise<Submission | undefined> {
    const db = await dbPromise;
    return db.get("submissions", id);
  }

  async function deleteSubmission(id: number): Promise<void> {
    const db = await dbPromise;
    await db.delete("submissions", id);
  }

  async function getSubmissions(): Promise<{
    submissions: Submission[];
    error: string | null;
  }> {
    const db = await dbPromise;
    try {
      const submissions = await db.getAll("submissions");
      return { submissions, error: null };
    } catch (error: any) {
      if (error instanceof DOMException || error instanceof Error) {
        return {
          submissions: [],
          error: error.message,
        };
      }
      return {
        submissions: [],
        error: "Failed to retrieve submissions.",
      };
    }
  }

  return {
    saveSubmission,
    getSubmission,
    deleteSubmission,
    getSubmissions,
  };
}
